import React from 'react';
import moment from "moment/moment";

const DateInfo = ({redemptionDate, paymentDate, countDays, firstPaymentDays}) => {
    return (
        <div className="form-row-item calculationLayout-element overview-top">
            <p>
                Дата залога
                <span className={"letter-spacing font-bold"}>
                    {moment().format("DD.MM.YYYY")}
                  </span>
            </p>
            <p>
                Дата выкупа
                <span className={"letter-spacing font-bold"}>
                    {moment(redemptionDate).format("DD.MM.YYYY")}
                  </span>
            </p>
            {paymentDate && <p>
                Дата первого платежа
                <span className={"letter-spacing font-bold"}>
                    {moment(paymentDate).format("DD.MM.YYYY")}
                  </span>
            </p>}
            <p>
                Количество дней
                <span className={"letter-spacing font-bold"}>
                    {countDays}
                  </span>
            </p>
            {firstPaymentDays && <p>
                Количество дней до первого платежа
                <span className={"letter-spacing font-bold"}>
                    {firstPaymentDays}
                  </span>
            </p>}
        </div>
    );
};

export default DateInfo;